"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  placeholder: 'Chọn thời gian',
  rangePlaceholder: ['Bắt đầu', 'Kết thúc']
};
var _default = exports.default = locale;